import React from 'react';
import PropTypes from 'prop-types';
import styles from './CanvasClose.css';
import { IconShapeCross } from '@xingternal/malt-icon';
import classNames from 'classnames';
import testable from '@xingternal/malt-util/testable';
import { QA_MALT } from '@xingternal/malt-constants';

const TestableButton = testable(QA_MALT, 'button');

/* Yeah, right. Too late. Sure. Eat this! */
export const CLOSE_COLOR_BLACK = 'CLOSE_COLOR_BLACK';
export const CLOSE_COLOR_WHITE = 'CLOSE_COLOR_WHITE';
export const COLORS = [CLOSE_COLOR_BLACK, CLOSE_COLOR_WHITE];

export default function CanvasClose({ onClick, color, testId }) {
  const classes = classNames(
    styles.close,
    color === CLOSE_COLOR_WHITE ? styles.white : styles.black
  );

  return (
    <TestableButton className={classes} onClick={onClick} testId={testId}>
      <IconShapeCross className={styles.closeIcon} />
    </TestableButton>
  );
}

CanvasClose.propTypes = {
  /** click handler for the button */
  onClick: PropTypes.func.isRequired,
  /** @private */
  color: PropTypes.oneOf([CLOSE_COLOR_BLACK, CLOSE_COLOR_WHITE]),
  /** define a testId for the canvas close button */
  testId: PropTypes.string,
};

CanvasClose.displayName = 'CanvasClose';
